import React from 'react';
import { FaGithub, FaTwitter, FaYoutube, FaLinkedin } from 'react-icons/fa';

function Footer() {
  const iconStyle = { width: 24, height: 24, verticalAlign: 'middle' };
  const linkStyle = { color: 'inherit', marginRight: 12, display: 'inline-block' };

  return (
    <footer style={{ padding: '1rem', textAlign: 'center' }}>
      <div style={{ marginBottom: '0.5rem' }}>
        <a
          href="https://github.com/mayanksonidev"
          aria-label="GitHub"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          <FaGithub style={iconStyle} aria-hidden="true" />
        </a>

        <a
          href="https://x.com/mayanksonidev"
          aria-label="X"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          <FaTwitter style={iconStyle} aria-hidden="true" />
        </a>

        <a
          href="https://www.youtube.com/@mayanksonidev"
          aria-label="YouTube"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          <FaYoutube style={iconStyle} aria-hidden="true" />
        </a>

        <a
          href="https://www.linkedin.com/in/mayanksonidev"
          aria-label="LinkedIn"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          <FaLinkedin style={iconStyle} aria-hidden="true" />
        </a>
      </div>

      <p>&copy; Copyright © Mayank Soni. All rights reserved.</p>
    </footer>
  );
}

export default Footer;